import { render, staticRenderFns } from "./SortDropdown.vue?vue&type=template&id=1e643bfe&"
import script from "./SortDropdown.vue?vue&type=script&lang=ts&"
export * from "./SortDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports